import angular from 'angular';
import uiRouter from 'angular-ui-router';
import totalauditComponent from './totalaudit.component';

let totalauditModule = angular.module('totalaudit', [
  uiRouter
])

.component('totalaudit', totalauditComponent);

export default totalauditModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/totalaudit/totalaudit.js